import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { Db2LinkedService } from '../linkedservice/db2.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.db2.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Db2_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Db2_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: Db2LinkedService.MODEL // Linked service redefined
        }
    }
})
export class DB2Dataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
